import { useEffect, useMemo, useState } from 'react';
import type { Socket } from 'socket.io-client';
import { SocketNamespace } from '@trinity/chat';
import { createLogger } from '../utils';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

export const useReportsSocket = (identifier: string): Socket => {
  const [socket, setSocket] = useState<Socket>();
  const getSocket = useGetSocket(SocketNamespace.Reports);

  const logger = useMemo(() => createLogger({
    namespace: SocketNamespace.Reports,
  }), []);

  useEffect(() => {
    if (identifier) {
      logger.log(`Setting up socket for report: ${identifier}`);
      const newSocket = getSocket();

      setSocket(newSocket);

      logger.log(`Subscribing to report: ${identifier}`);
      newSocket.emit('subscribe', identifier);

      return () => {
        logger.log(`Cleaning up socket for report: ${identifier}`);
        newSocket.emit('unsubscribe', identifier);
        newSocket.disconnect();
      };
    }
  }, [getSocket, identifier, logger]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.Reports);

  return socket;
};